// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1CoWW","modalFooterButton":"ModalNotes_modalFooterButton__RkquW"};